export default __webpack_public_path__ + "static/media/medall-alt.87319580.svg";